$(".register-form__btn").on("click", function () {
  const step = $(this).data("step");
  if (step === 1) {
    $(".register-form__step").removeClass("active");
    $(".register-form__step[data-step='" + (step + 1) + "']").addClass(
      "active"
    );
    window.scrollTo(0, 0);
  } else if (step === 2) {
    $(".register-form__step").removeClass("active");
    $(".register-form__header").removeClass("active");
    $(".register-form__header--end").addClass("active");
    window.scrollTo(0, 0);
  }
});

$(".register-form__return").on("click", function () {
  $(".register-form__header").removeClass("active");
  $(".register-form__step").removeClass("active");
  $(".register-form__header--start").addClass("active");
  $(".register-form__step[data-step='1']").addClass("active");
  window.scrollTo(0, 0);
});

$("#submit-all").on("click", function () {
  submitAll($(this).parents("form").data("id"));
});

$("input[type=radio][name=individualAccessCode]").change(function () {
  this.value == '1'
    ? $(".hidden-field").slideDown(300)
    : $(".hidden-field").slideUp(300);
});

function submitAll(className) {
  const inputs = $("." + className + "-form__step[data-step='2'] input:radio");
  for (let i = 0; i < inputs.length; i++) {
    if (i % 2 == 0 || i == 0) {
      $("." + className + "-form__step[data-step='2'] input:radio")
        .eq(i)
        .attr("checked", "checked");
    }
  }
}
